import React, { useEffect } from 'react';
import { Spin } from 'antd';
import '../Logout/Logout.css';
import { useNavigate } from 'react-router-dom';
import AuthentificationService from '../../services/authentification/AuthentificationService';

const Logout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AuthentificationService.logout()
      .then((data) => {
        if (data) {
          navigate('/');
        } else {
          console.error(
            'Received data is not in JSON format or JSON parsing failed.'
          );
        }
      })
      .catch((error) => {
        console.error('Error processing your request:', error);
      });
  }, []);

  return (
    <div className='content'>
      {
        <div className='spin-container'>
          <Spin
            size='large'
            tip='Logging out...'
            fullscreen={true}
            delay={2000}
          />
        </div>
      }
    </div>
  );
};

export default Logout;
